import { Datasheet } from "@/api/datasheets";
import { ParalloyWeld } from "@/api/paralloy/rbi";
import { Project } from "@/api/project";
import { SubProject } from "@/api/subProject";

export type ParalloyState = {
  project?: Project;
  subProject?: SubProject;
  datasheet?: Datasheet;
  welds: ParalloyWeld[];
};

export const defaultState: ParalloyState = {
  welds: [],
};

export type StateType = "Project" | "SubProject" | "Datasheet" | "Welds";
